import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Check, Sparkles, Loader2, X } from "lucide-react";
import { PRO_FEATURES } from "../constants/models";

export default function UpgradeModal({ open, onOpenChange, reason, onUpgrade, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden gap-0 border-0" data-testid="upgrade-modal">
        <DialogTitle className="sr-only">Upgrade to OmniAI Pro</DialogTitle>
        <DialogDescription className="sr-only">Unlock all 16 models, image generation and Compare Mode for $10 per month.</DialogDescription>
        {/* Header */}
        <div className="relative bg-[#1F2421] px-6 pt-7 pb-6 text-white">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 15% 15%, #2D6A4F 0, transparent 45%), radial-gradient(circle at 85% 60%, #1A73E8 0, transparent 40%)" }} />
          <button onClick={() => onOpenChange(false)} className="absolute right-4 top-4 text-white/60 hover:text-white z-10" data-testid="upgrade-close">
            <X className="h-4 w-4" />
          </button>
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1 mb-4">
              <Sparkles className="h-3.5 w-3.5 text-[#7FD3AC]" />
              <span className="text-xs font-semibold tracking-wide">OMNIAI PRO</span>
            </div>
            <h2 className="font-heading text-3xl font-bold tracking-tight">Unlock everything</h2>
            {reason && <p className="mt-2 text-sm text-white/70">{reason}</p>}
            <div className="mt-4 flex items-baseline gap-1.5">
              <span className="font-heading text-4xl font-bold">$10</span>
              <span className="text-white/60 text-sm">/ month</span>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="px-6 py-5 bg-white">
          <ul className="space-y-3">
            {PRO_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-3">
                <span className="mt-0.5 h-5 w-5 shrink-0 rounded-full bg-[#EAF3EE] flex items-center justify-center">
                  <Check className="h-3.5 w-3.5 text-[#2D6A4F]" strokeWidth={3} />
                </span>
                <span className="text-sm text-[#26261F]">{f}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={onUpgrade}
            disabled={loading}
            data-testid="upgrade-checkout-button"
            className="mt-6 w-full flex items-center justify-center gap-2 rounded-xl bg-[#1F2421] text-white py-3.5 font-medium hover:bg-[#2D6A4F] disabled:opacity-60"
            style={{ transition: "background-color 0.2s ease" }}
          >
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Redirecting…</> : <>Upgrade to Pro — $10/mo</>}
          </button>
          <p className="mt-3 text-center text-[11px] text-[#8C8C85]">Secure checkout via Stripe. Cancel anytime.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
